import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { Share } from '@capacitor/share';

export interface ShareTextOptions {
  title?: string;
  text?: string;
  url?: string;
  dialogTitle?: string;
}

export async function openExternalUrl(url: string): Promise<void> {
  if (!url) {
    return;
  }

  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url });
    return;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
}

export async function shareText(options: ShareTextOptions): Promise<'shared' | 'copied' | 'unsupported'> {
  if (Capacitor.isNativePlatform()) {
    await Share.share(options);
    return 'shared';
  }

  if (navigator.share) {
    await navigator.share({
      title: options.title,
      text: options.text,
      url: options.url
    });
    return 'shared';
  }

  const content = [options.title, options.text, options.url].filter(Boolean).join('\n\n');
  if (navigator.clipboard && content) {
    await navigator.clipboard.writeText(content);
    return 'copied';
  }

  return 'unsupported';
}
